<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script setup>


</script>

<style>
#app{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
